import React from 'react'
import { withRouter } from 'react-router'

let LegalNotice = ({location}) => {

  if(location.pathname === '/sweeps/m'){
    return (<div className="legalNotice">NO PURCHASE NECESSARY.  PURCHASES DO NOT INCREASE ODDS OF WINNING.  Odds depend on number of eligible entries received.  VOID WHERE PROHIBITED.  Open to males who are legal residents of U.S. or D.C., age 18+.  Prize value: $1,000.  For Official Rules, see blog.match.com/ratethedatelook.  Sponsors: Match.com, LLC, 8750 N. Ctrl Expy, Ste. 1400, Dallas, TX 75231; and Tête-à-Tête, Inc., 305 W. Broadway, #198, New York, NY 10013.  Enter by 7/2.</div>)
  }else{
    return null
  }

}

export default LegalNotice = withRouter(LegalNotice)



// WEBPACK FOOTER //
// ./src/templates/LegalNotice.js